import React from "react";
import { isOutsideCmpny } from "../../function/common";
import { IoTimeOutline } from "react-icons/io5";
import moment from "moment";
import { calculateDday, isEventCategory, showEventTime } from "../../function/common";
import { useSelector } from "react-redux";
import { EventTitleContainer } from "../../styled/scheduler";

const ScheduleInfo = ({ active, eventInfo, comments, isSchedule, isDetail = false, isProject }) => {
  const company = useSelector((state) => state?.company?.data);
  const user = useSelector((state) => state?.user?.data[0]);

  const { isDarkMode } = useSelector((state) => state.scheduler);

  const getColor = (gbn, color) => {
    const colorMap = {
      C: "0074ca",
      G: "F46F02",
    };
    return colorMap[gbn] || color || "333";
  };

  const renderEventTitle = () => (
    <div
      style={{ borderLeft: `5px solid #${getColor(eventInfo.gbn, eventInfo.color)}` }}
      className={`title ${eventInfo.gbn}${isOutsideCmpny(eventInfo, company) ? " outside" : ""}`}>
      {eventInfo.icon && (
        <img src={`/img/scheduler/scheduler_icon_${eventInfo.icon}`} alt="event icon" />
      )}
      <p className={eventInfo.completeYn === "Y" ? "complete" : ""}>{eventInfo.title}</p>
    </div>
  );

  const renderScheduleInfo = () => {
    if (!isSchedule) return null;
    const { gbn, managerNm, orgNm } = eventInfo;
    const isPrivate = gbn === "P";

    return (
      <span>
        {isPrivate && String(user.mberNo) !== eventInfo.mberNo && managerNm && `${managerNm}님의 `}
        {isPrivate && String(user.mberNo) !== eventInfo.mberNo ? "공유" : isEventCategory(gbn)}
        일정
        {!isPrivate && ` : ${orgNm}`}
      </span>
    );
  };

  const renderDetailedInfo = () => (
    <>
      <div
        className="dot"
        style={{
          background: isOutsideCmpny(eventInfo, company)
            ? "linear-gradient(rgb(0, 116, 202), rgb(237, 85, 131))"
            : `#${getColor(eventInfo.gbn, eventInfo.color)}`,
        }}></div>
      <ul>
        <li className="title">
          {eventInfo.icon && (
            <img src={`/img/scheduler/scheduler_icon_${eventInfo.icon}`} alt="event icon" />
          )}
          <span className={eventInfo.completeYn === "Y" ? "complete" : ""}>{eventInfo.title}</span>
        </li>
        {renderScheduleInfo()}
        <li className="date">
          <i>
            <IoTimeOutline />
          </i>
          {isSchedule
            ? showEventTime(eventInfo.startDt, eventInfo.endDt)
            : moment(eventInfo.startDt).format("YYYY년 M월 D일")}
        </li>
      </ul>
    </>
  );

  const componentInfo = {
    0: (
      <>
        {renderEventTitle()}
        {renderScheduleInfo()}
      </>
    ),
    1: renderDetailedInfo(),
    2: <p className="title">갤러리</p>,
    3: (
      <p className="title">
        총 <strong>{comments.length}</strong>개의 댓글
      </p>
    ),
    4: <p className="title">멤버</p>,
  };

  const dday = () => {
    return (
      <>
        <div
          style={{ borderLeft: `5px solid #${getColor(eventInfo.gbn, eventInfo.color)}` }}
          className="title">
          {eventInfo.icon && (
            <img src={`/img/scheduler/scheduler_icon_${eventInfo.icon}`} alt="event icon" />
          )}
          <p className={eventInfo.completeYn === "Y" ? "complete" : ""}>{eventInfo.title}</p>
        </div>
        <span>{calculateDday(eventInfo.startDt)}</span>
      </>
    );
  };

  return (
    <EventTitleContainer
      className={`view-${active} ${isProject ? "" : isDarkMode} ${isDetail ? "detail" : ""}`}>
      {eventInfo.dday === "Y" ? dday() : componentInfo[active]}
    </EventTitleContainer>
  );
};

export default ScheduleInfo;
